const Wrapper = ({ children }) => {
    return (
        <div className="py-2">
            <div className="row">
                {children}
            </div>
        </div>
    )
}

export default Wrapper
